<template>
  <div id="tab-container">
    <b-tabs
      type="is-toggle"
      :expanded="expanded"
      :animated="animated"
      @input="callback">
      <b-tab-item
        v-for="(option, i) in options"
        :key="`${option}-${i}`"
        :label="option.label"
        :icon="option.icon"
        :value="option.label"
        :visible="option.show"
        header-class="text-not-underline">
        <slot :name="i"> Slot {{ option.label }}</slot>
      </b-tab-item>
    </b-tabs>
  </div>
</template>

<script>
export default {
  name: 'Tabs',
  props: {
    animated: {
      type: Boolean,
      required: false,
      default: false
    },
    expanded: {
      type: Boolean,
      required: false,
      default: false
    },
    options: {
      type: Array,
      required: true,
      default: () => { return []; }
    },
    callback: {
      type: Function,
      required: false,
      default: () => { return []; }
    }
  },
  data() {
    return {
    };
  }
};
</script>

<style>
#tab-container div > nav.tabs > ul > li.is-active > a {
  margin-right: .5rem;
  color: white;
  background-color: var(--primary);
  color: white;
}

#tab-container div > nav.tabs > ul > li > a {
  margin: .5rem;
  border: none;
  border-radius: 7px;
  background-color: hsl(0, 0%, 96%);
  color: var(--info-dark);
}

#tab-container > div > section {
  padding: .5rem;
}
</style>
